import React from "react";
import { GridItem } from "@chakra-ui/react";
import { Form, Grid, Select } from "components";
import { FormWatcherCallback, useCurrentCase } from "duck";
import { PatientStateEnum } from "requests";
import { useUpdatePhysicalExam, FormValues } from "../../duck";
import { AllNormal } from "./components";
import { STATE_OPTIONS, getDefaultValues } from "./duck";

interface PhysicalExamFormProps {
  onOpen(): void;
  onFieldNameChange(name: string): void;
}

const PhysicalExamForm: React.FC<PhysicalExamFormProps> = ({
  onOpen,
  onFieldNameChange
}) => {
  const physicalExam = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.physicalExam
  );

  const defaultValues = React.useMemo(() => getDefaultValues(physicalExam), [
    physicalExam
  ]);

  const update = useUpdatePhysicalExam();

  const onChange = React.useCallback<FormWatcherCallback<FormValues>>(
    values => {
      if (Object.values(values)[0] === PatientStateEnum.Abnormal) {
        onOpen();
        onFieldNameChange(Object.keys(values)[0]);
      }

      return update(values);
    },
    [update, onFieldNameChange]
  );

  return (
    <Form<FormValues> defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={onChange} />

      <AllNormal />

      <Grid>
        <GridItem>
          <Select
            label="General Appearance"
            name="generalAppearance"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="gastrointestinal"
            label="Gastrointestinal"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="oralCavity"
            label="Oral Cavity"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="musculosceletal"
            label="Musculoskeletal"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="mucousMembranes"
            label="Mucous Membranes"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="lymphNodes"
            label="Lymph Nodes"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="eyes"
            label="Eyes"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="urogenital"
            label="Urogenital"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="ears"
            label="Ears"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="integumentary"
            label="Integumentary"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="cardiovascular"
            label="Cardiovascular"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="nervousSystem"
            label="Nervous System"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
        <GridItem>
          <Select
            name="respiratory"
            label="Respiratory"
            options={STATE_OPTIONS}
            placeholder="Select a State"
          />
        </GridItem>
      </Grid>
    </Form>
  );
};

export default PhysicalExamForm;
